import React, {useContext} from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row, Card, CardBody, InputGroupAddon,
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import {useRouterStore} from "mobx-state-router";
import Select from "react-select";
import {StateContext} from "../../../App";
import {createCustomAjvValidator} from "../../../services/AjvValidator";
import {Theme as Bootstrap4Theme} from "@rjsf/bootstrap-4";
import {withTheme} from "@rjsf/core";
import {batchTypesConstatns} from "../../../utils/constants";
import LockButton from "../../elements/batch/LockButton";

const ThemedForm = withTheme(Bootstrap4Theme);

const ExtendedDataSettingModal = observer(({store, currentState}) => {
  const stateContext = useContext(StateContext);
  const routerStore = useRouterStore();
  const intl = useIntl();
  const { params } = routerStore.routerState;
  //TODO: PATTERN VIOLATION - createCustomAjvValidator called on every render (affects 10+ components)
  // Correct solution: Use shared validator from RootUiState (see commented code in src/stores/RootUiState.js)
  // Replace with: const validator = stateContext.rootUiStore.ajvValidator;
  const validator = createCustomAjvValidator();

  const uiSchema = {};
  const widgets = {};

  //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
  // See correct pattern: Call in route onEnter (src/routes/codes/index.js) or as MST action
  store?.setOnSelectChanges();
  const isDisabled = store.isView;

  return (
    <Card>
      <disableWrapper isDisabled={isDisabled}>
        <CardBody>
        <Row>
          <Col sm={2}>
            <FormGroup check>
              <Input
                name="addExtendedData"
                type="radio"
                id="addExtendedData"
                checked={store?.showDropdown}
                onClick={store?.toggleDropdownVisibility}
                disabled={isDisabled}
              />
              <Label check>
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.new.defaultMessage"/>
              </Label>
            </FormGroup>
          </Col>
          {store?.showDropdown &&
            <Col sm={6}>
              <InputGroup className="mb-3">
                <InputGroupAddon addonType="prepend">
                  Autofill Form
                </InputGroupAddon>
                <Select
                  sm={10}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  defaultValue={store?.getAutoFillDefaultValues()}
                  options={store?.getAutoFillOptionValues()}
                  isSearchable
                  isMulti
                  onChange={(data) => store?.onAutoFillSelectChange(data)}
                  getOptionLabel={option => option.label}
                  getOptionValue={option => option.uuid}
                  placeholder="Select"
                  // dropdown placement relative to viewport
                  menuPortalTarget={document.querySelector('.text-center.m-3.modal-body')}
                  menuPlacement="auto"
                  menuPosition="fixed"
                  isDisabled={isDisabled}
                />
              </InputGroup>
            </Col>
          }
          <Col sm={2}>
            <FormGroup check>
              <Input
                name="addExtendedData"
                type="radio"
                id="noneExtendedData"
                checked={!store?.showDropdown}
                onClick={store?.toggleDropdownVisibility}
                disabled={isDisabled}
              />
              <Label check>
                None
              </Label>
            </FormGroup>
          </Col>
        </Row>
        {store?.showDropdown &&
          <Row className="p-1">
            <Col sm={12}>
              <InputGroup className="mb-3">
                <InputGroupAddon addonType="prepend">
                  Extended Data
                </InputGroupAddon>
                <Select
                  sm={10}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  defaultValue={store?.getExtendedDefaultValues()}
                  options={store?.getExtendedOptionValues()}
                  isSearchable
                  isMulti
                  onChange={(data) => store?.onExtendedSelectChange(data)}
                  getOptionLabel={option => option.label}
                  getOptionValue={option => option.uuid}
                  placeholder="Select"
                  // dropdown placement relative to viewport
                  menuPortalTarget={document.querySelector('.text-center.m-3.modal-body')}
                  menuPlacement="auto"
                  menuPosition="fixed"
                  isDisabled={isDisabled}
                />
              </InputGroup>
            </Col>
          </Row>
        }
        {store?.showDropdown && Object.keys(store?.extendedDataSchema)?.length ?
          <>
            <hr/>
            <Row className="p-1">
              <Label sm={3} className="text-sm-right">
                Extended Experience Detail(s)
              </Label>
              <Col sm={8}>
                <ThemedForm
                  validator={validator}
                  schema={store?.extendedDataSchema}
                  uiSchema={uiSchema}
                  formData={store?.formData}
                  widgets={widgets}
                  onChange={(data) => {
                    store?.updateExtendedFormData(data.formData);
                  }}
                  showErrorList={false}
                  liveValidate={store?.liveValidateSchema}
                  transformErrors={store?.transformErrors}
                  disabled={isDisabled || store?.batchExtendedDataNochanges}
                >
                  <div></div>
                </ThemedForm>
              </Col>
              {currentState?.batchType && currentState?.batchType === batchTypesConstatns.EDIT && (
                <Col sm={1}>
                  <LockButton
                    isDisabled={store?.batchExtendedDataNochanges}
                    onReset={store?.resetExtendedDataOnUnlock}
                    onToggle={store?.setExtendedDataLock}
                  />
                </Col>
              )}
            </Row>
          </> : <></>
        }
        <Row className="p-1">
          <Col sm={2}>
            <Button color="secondary" onClick={async () => {
              //store?.clearState();
              currentState?.modalStore.toggle();
            }}>
              <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/>
            </Button>
          </Col>
          <Col sm={10} className="text-right">
            <Button outline color="primary" disabled={isDisabled} onClick={async () => {
              if (store?.validateForm()) {
                currentState?.modalStore.toggle();
              }
            }}>
              <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage"/>
            </Button>
          </Col>
        </Row>
      </CardBody>
      </disableWrapper>
    </Card>
  );
})

export default ExtendedDataSettingModal;
